export enum SynchronizationStatus {
  INACTIVATED = 'INACTIVATED',
  DESYNCHRONIZED = 'DESYNCHRONIZED',
  SYNCHRONIZING = 'SYNCHRONIZING',
  SYNCHRONIZED = 'SYNCHRONIZED',
}
